import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-search-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">
              磁力搜索指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-600 bg-primary-100/70"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith("/category")
                    ? "text-primary-600 bg-primary-100/70"
                    : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                }`}
              >
                分类导航
                <i
                  className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${
                    categoryOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 border border-background-200/80 rounded-xl shadow-lg py-2 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-150"
                    >
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </div>
                      <span className="whitespace-nowrap">{cat.name}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-600 bg-primary-100/70"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
          >
            <i
              className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 flex flex-col gap-1">
          <Link
            to="/"
            className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === "/"
                ? "text-primary-600 bg-primary-100/70"
                : "text-foreground-700 hover:bg-background-100"
            }`}
          >
            首页
          </Link>
          <div className="px-4 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
            分类导航
          </div>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${cat.icon} text-base`}></i>
              </div>
              <span className="whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === "/about"
                ? "text-primary-600 bg-primary-100/70"
                : "text-foreground-700 hover:bg-background-100"
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}